/** Причина действия, которое выполняется с обязательным обоснованием (`requireReason` у кнопки). */
export interface IActionReason {
    reason: string;
    /** Номер обращения; необязателен. */
    ticketRef?: string;
}

/** Ограничения — те же, что проверяет сервер. */
export const ACTION_REASON_MAX_LENGTH = 500;
export const ACTION_TICKET_MAX_LENGTH = 64;

/** Тело запроса: номер обращения — только если указан. */
export const actionReasonBody = ({ reason, ticketRef }: IActionReason): IActionReason => {
    const ticket = ticketRef?.trim();
    return ticket ? { reason: reason.trim(), ticketRef: ticket } : { reason: reason.trim() };
};

/** Причина у кнопки действия: `requireReason` и `reasonLabel` из ClientOptions. */
export interface IActionReasonOptions {
    requireReason?: boolean;
    /** Подпись поля причины. */
    reasonLabel?: string;
}

export const readActionReasonOptions = (options: unknown): IActionReasonOptions => {
    const source = (typeof options === 'object' && options !== null ? options : {}) as Record<string, unknown>;
    return {
        requireReason: source.requireReason === true,
        reasonLabel: typeof source.reasonLabel === 'string' ? source.reasonLabel : undefined,
    };
};
